
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { API } from '../../utils/api';

export function AdminSystem({ headers }) {
  const [incidentStatus, setIncidentStatus] = useState({ active: false, kill_switch_until: null });

  const fetchIncidentStatus = async () => {
    try {
      const res = await axios.get(`${API}/admin/incident-response`, { headers });
      setIncidentStatus(res.data);
    } catch (e) {
      console.error('Failed to load incident status');
    }
  };

  useEffect(() => {
    fetchIncidentStatus();
  }, []);
  const handleReset = async () => {
    if (!window.confirm('⚠️ DANGER: This will reset the ENTIRE system.\n\n- All transactions archived\n- All user bindings deleted\n- All watches unbound\n\nAre you absolutely sure?')) return;
    
    const pwd = window.prompt("Enter System Reset Password:");
    if (pwd !== "654321") {
      toast.error("Incorrect password. Action cancelled.");
      return;
    }

    try {
      const res = await axios.post(`${API}/admin/system/reset`, {}, { headers });
      toast.success(`System Reset Complete. Archived ${res.data.archived_requests} requests and ${res.data.archived_payments} payments.`);
    } catch (e) {
      toast.error('Failed to reset system');
    }
  };

  const activateKillSwitch = async () => {
    try {
      const res = await axios.post(`${API}/admin/incident-response/activate`, {}, { headers });
      setIncidentStatus(res.data);
      toast.success('Kill-switch activated for 24 hours');
    } catch (e) {
      toast.error('Failed to activate kill-switch');
    }
  };

  const disableKillSwitch = async () => {
    try {
      const res = await axios.post(`${API}/admin/incident-response/disable`, {}, { headers });
      setIncidentStatus(res.data);
      toast.success('Kill-switch disabled');
    } catch (e) {
      toast.error('Failed to disable kill-switch');
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-red-600">System Operations</h2>
      
      <Card className="border-red-200 bg-red-50">
        <CardHeader>
          <CardTitle className="text-red-700">System Reset</CardTitle>
          <CardDescription className="text-red-600">
            This action effectively "wipes" the operational state of the system for a fresh start, while preserving data for audit.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <ul className="list-disc list-inside text-sm text-red-700 space-y-1">
              <li>Archives all active requests and payments</li>
              <li>Removes all Payer-Buddy bindings</li>
              <li>Unbinds all WatchPay devices (resets to IN_STOCK)</li>
              <li>Deletes all temporary 'watchpay' user accounts</li>
            </ul>
            <Button variant="destructive" onClick={handleReset} className="w-full sm:w-auto">
              ⚠️ Reset System
            </Button>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Incident Response</CardTitle>
          <CardDescription>
            24‑hour kill‑switch to pause payment processing during incidents.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div className="text-sm" data-testid="kill-switch-status">
              Status: <strong>{incidentStatus.active ? 'ACTIVE' : 'INACTIVE'}</strong>
            </div>
            {incidentStatus.kill_switch_until && (
              <div className="text-xs text-muted-foreground">Active until: {incidentStatus.kill_switch_until}</div>
            )}
            <div className="flex gap-2">
              <Button
                variant="destructive"
                onClick={activateKillSwitch}
                data-testid="activate-kill-switch"
              >
                Activate 24h Kill‑Switch
              </Button>
              <Button
                variant="outline"
                onClick={disableKillSwitch}
                data-testid="disable-kill-switch"
              >
                Disable
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
